var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_11279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.44922H1.5C1.05 3.44922 0.75 3.74922 0.75 4.19922C0.75 4.64922 1.05 4.94922 1.5 4.94922H2.55V13.7242C2.55 15.6742 4.05 17.2492 6 17.2492H12C13.95 17.2492 15.45 15.6742 15.45 13.7992V4.94922H16.5C16.95 4.94922 17.25 4.64922 17.25 4.19922C17.25 3.74922 16.95 3.44922 16.5 3.44922Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2998 2.25H11.7748C12.2248 2.25 12.5248 1.95 12.5248 1.5C12.5248 1.05 12.2248 0.75 11.7748 0.75H6.2998C5.8498 0.75 5.5498 1.05 5.5498 1.5C5.5498 1.95 5.8498 2.25 6.2998 2.25Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9751 13.8754C6.5251 13.8754 6.2251 13.5754 6.2251 13.1254V7.65039C6.2251 7.20039 6.5251 6.90039 6.9751 6.90039C7.4251 6.90039 7.7251 7.20039 7.7251 7.65039V13.1254C7.7251 13.5004 7.3501 13.8754 6.9751 13.8754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0249 13.8754C10.5749 13.8754 10.2749 13.5754 10.2749 13.1254V7.65039C10.2749 7.20039 10.5749 6.90039 11.0249 6.90039C11.4749 6.90039 11.7749 7.20039 11.7749 7.65039V13.1254C11.7749 13.5004 11.4749 13.8754 11.0249 13.8754Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_11279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a38c7d57b9adb48bf4672b403011da4e.svg";
export { ForwardRef as ReactComponent };